module.exports = __webpack_public_path__ + "resource/img/image053Dark.d1cf9b7e.png";